import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbDigitalTermService {
	private updateSignatureUrl = environment.baseApiUrl + 'cmdbDigitalTerm/signature/{uuid}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	updateSignature(uuid: string): Observable<any> {
		const updateSignatureUrl = this.updateSignatureUrl.replace('{uuid}', uuid);

		return this.http.put<any>(updateSignatureUrl, {}, { headers: this.headers });
	}
}
